// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"314":"68d9cc3e","373":"70a0bd4a","422":"c5a364ca","482":"584a11e4","639":"6626e395","692":"2eba7110","924":"14da4f5f"}[chunkId] + ".js";
};